import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router, ActivatedRouteSnapshot, UrlSegment} from '@angular/router';

import {AppSettings} from '../../../app.settings';
import {Settings} from '../../../models/settings.model';
import {MobileCheckServiceService} from '../../../services/mobile-check-service.service';
import {MultiTenantService} from '../../../services/multi-tenant.service';

@Component({
    selector: 'app-breadcrumb',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
    public settings: Settings;
    public pageTitle: string;
    public breadcrumbs: {
        name: string;
        url: string
    }[] = [];

    @Input()  productLabel = '';

    constructor(public appSettings: AppSettings,
                public router: Router,
                public activatedRoute: ActivatedRoute,
                private mobileCheck: MobileCheckServiceService,
                private multitenantService: MultiTenantService) {

        this.settings = this.appSettings.settings;
    }

    ngOnInit() {
        this.breadcrumbs = [];
        this.parseRoute(this.router.routerState.snapshot.root);
        this.pageTitle = '';
        this.breadcrumbs.forEach(breadcrumb => {
            this.pageTitle += ' / ' + breadcrumb.name;
        })
    }


    parseRoute(node: ActivatedRouteSnapshot) {
        if (node.data['breadcrumb']) {
            if (node.url.length || node.pathFromRoot.length) {
                let urlSegments: UrlSegment[] = [];
                node.pathFromRoot.forEach(routerState => {
                    urlSegments = urlSegments.concat(routerState.url);
                });
                const url = urlSegments.map(urlSegment => {
                    return urlSegment.path;
                }).join('/');

                let tempName = this.multitenantService.getMappedBreadcrumbName(node.data['breadcrumb'])  ;
                if (node.params[tempName]) {
                    let value = node.params[tempName];

                    if (tempName.indexOf('-slug') > -1) {
                        const tokens = value.replace('-amp-', '-&-').split('-');
                        if (!isNaN(tokens[0])) {
                            tokens.shift();
                        }
                        value = tokens.join(' ').toUpperCase();
                    }

                    tempName = value;
                }

                if (tempName.length === 0 && node.url.length > 0) {
                    tempName = node.url[0].path;
                }

                if (node.data['breadcrumbPrefix']) {
                    tempName = `${node.data['breadcrumbPrefix']}${tempName}`;
                }

                if (tempName && !this.breadcrumbs.find( b => b.name === tempName)) {
                    console.log('breadcrumb', tempName, url);
                    this.breadcrumbs.push({
                        name: tempName,
                        url: '/' + url
                    });
                }
            }
        }
        if (node.firstChild) {
            this.parseRoute(node.firstChild);
        }
    }


    public closeSubMenus() {
        const menu = document.querySelector('#menu0');
        if (menu) {
            for (let i = 0; i < menu.children.length; i++) {
                const child = menu.children[i].children[1];
                if (child) {
                    if (child.classList.contains('show')) {
                        child.classList.remove('show');
                        menu.children[i].children[0].classList.add('collapsed');
                    }
                }
            }
        }
    }


    public breadcrumbName(name, overrideLabel = ''): string {
        if (overrideLabel) {
            return overrideLabel;
        }
        const path = `/cart/${name}`;
        if (this.router.url.includes(path) && name !== 'Checkout') {
            return `Order #${name}`;
        }
        return name;
    }

    get mobile(): boolean {
        return this.mobileCheck.mobile;
    }
}
